import React from 'react';
import { type Interaction } from '@lib/models/Interaction';
// Mobile responsive imports

import MessageUser from './MessageUser';
import MessageAgent from './MessageAgent';
import type { IArtifactService } from '@lib/services/interfaces/artifactService';
import { EventBusService } from '@lib/services/eventBusService';
import { useAiChatServices } from '../AiChatContext';

interface MessageProps {
  message: Interaction;
  onLinkClicked: (link: string, content: string | null) => void;
  appendWaitingPart: boolean;
  messagesRef?: React.RefObject<Map<string, HTMLDivElement>>;
  friendlyMode?: boolean;
}

const Message: React.FC<MessageProps> = ({ message, onLinkClicked, appendWaitingPart, messagesRef, friendlyMode }) => {
  const { showSubAgents } = useAiChatServices();
  return (
    <>
      <MessageUser message={message} onLinkClicked={onLinkClicked} />
      <MessageAgent showSubAgents={showSubAgents !== false} onGoing={false} container='message' isConnectionOpen={true} message={message} onLinkClicked={onLinkClicked} appendWaitingPart={appendWaitingPart} messagesRef={messagesRef} preview={false} friendlyMode={friendlyMode} />

    </>
  );
};

export default Message;